import { useAuthState } from "react-firebase-hooks/auth";
import { useQuery } from "react-query";
import { auth } from "../firebase";
import { getUnreadNotifications } from "../services/users/users.api";
import { useUserPartnerInformation } from "./useUserPartnerInformation";

export function useNotifications() {
  const [user] = useAuthState(auth);

  const { userPartnerInformation } = useUserPartnerInformation(user?.uid);

  const { data: notifications, ...rest } = useQuery(
    "notifications",
    () => getUnreadNotifications(userPartnerInformation?.data?.partnerId),
    { enabled: !!userPartnerInformation?.data?.partnerId }
  );

  return { notifications, ...rest };
}
